import React, { Component } from "react";
import _ from "lodash";
import { LoadSvg, PinchZoomPan } from "../../components";
import correctIcon from "./svg/select-seat.svg";
import userIcon from "./svg/user-shape.svg";

export default class Mapsite extends Component {
  static defaultProps = {
    emptySeat: [],
    selectedSeat: [],
  };

  state = {
    onReady: false,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.onReady) {
      if (!_.isEqual(this.state.onReady, prevState.onReady)) {
        const seats = document.querySelectorAll("#mapsit g[id^='seat_']");
        for (let i = 0; i < seats.length; i++) {
          seats[i].addEventListener("click", this.handleClickSeat);
          seats[i].addEventListener("touchstart", this.handleClickSeat);
        }
      }
      if (!_.isEqual(this.props.emptySeat, prevProps.emptySeat)) {
        _.map(prevProps.emptySeat, (seatId) => {
          this.setPerson("remove", seatId);
        });
        if (_.size(this.props.emptySeat) > 0) {
          this.initPerson();
        }
      }
      if (!_.isEqual(this.props.selectedSeat, prevProps.selectedSeat)) {
        _.map(prevProps.selectedSeat, (seatId) => {
          if (!_.includes(this.props.selectedSeat, seatId)) {
            this.removeSeat(seatId);
          }
        });
        this.initSeat();
      }
    }
  };

  componentWillUnmount() {
    const seats = document.querySelectorAll("#mapsit g[id^='seat_']");
    for (let i = 0; i < seats.length; i++) {
      seats[i].removeEventListener("click", this.handleClickSeat);
      seats[i].removeEventListener("touchstart", this.handleClickSeat);
    }
  }

  initSeat = () => {
    const { selectedSeat } = this.props;
    _.map(selectedSeat, (seatId) => {
      this.addSeat(seatId);
    });
  };

  initPerson = () => {
    setTimeout(() => {
      const { emptySeat } = this.props;
      _.map(emptySeat, (seatId) => {
        this.setPerson("add", seatId);
      });
    }, 100);
  };

  handleClickSeat = (event) => {
    event.preventDefault();
    const seat = event.currentTarget.getAttribute("id");
    const seatId = _.replace(seat, "seat_", "");
    this.props.onClickSeat(seatId);
  };

  addSeat = (seatId) => {
    this.setSeat("add", seatId);
  };
  removeSeat = (seatId) => {
    this.setSeat("remove", seatId);
  };

  setPerson = (action, seatId) => {
    const id = `#seat_${seatId}`;
    const seat = document.querySelector(id);
    if (!seat) return;

    const bbox = seat.getBBox();

    const x = bbox.x;
    const y = bbox.y;

    const iconPersonNode = document.querySelector(`.icon_person_${seatId}`);

    if (action === "add") {
      if (iconPersonNode) return;
      const personImgNode = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "image"
      );
      personImgNode.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        userIcon
      );
      personImgNode.setAttributeNS(null, "class", `icon_person_${seatId}`);
      personImgNode.setAttributeNS(null, "x", x + 1);
      // personImgNode.setAttributeNS(null, "x", x);
      personImgNode.setAttributeNS(null, "y", y + 4);
      personImgNode.setAttributeNS(null, "height", "18px");
      personImgNode.setAttributeNS(null, "width", "18px");
      // personImgNode.setAttributeNS(null, "height", "25px");
      // personImgNode.setAttributeNS(null, "width", "25px");
      seat.appendChild(personImgNode);
      seat.setAttribute("class", "person");
    } else {
      // if (!iconPersonNode) return;
      // iconPersonNode.remove();
      // seat.setAttribute("class", "");
    }
  };

  setSeat = (action, seatId) => {
    const id = `#seat_${seatId}`;
    const seat = document.querySelector(id);
    if (!seat) return;

    const bbox = seat.getBBox();
    const x = bbox.x;
    const y = bbox.y;

    const rects = document.querySelectorAll(`${id} rect`);
    const paths = document.querySelectorAll(`${id} path`);
    for (let i = 0; i < rects.length; i++) {
      const rect = rects[i];
      rect.style.fill = action === "add" ? "#ffffff" : null;
    }
    for (let i = 0; i < paths.length; i++) {
      const path = paths[i];
      path.style.fill = action === "add" ? "#ffffff" : null;
    }

    const iconCorrectNode = document.querySelector(`.icon_correct_${seatId}`);

    if (action === "add") {
      if (iconCorrectNode) return;
      const correctImgNode = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "image"
      );
      correctImgNode.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        correctIcon
      );
      correctImgNode.setAttributeNS(null, "class", `icon_correct_${seatId}`);
      correctImgNode.setAttributeNS(null, "x", x + 4);
      correctImgNode.setAttributeNS(null, "y", y + 1.5);
      // correctImgNode.setAttributeNS(null, "x", x + 15 / 4);
      // correctImgNode.setAttributeNS(null, "y", y + 15 / 4);
      correctImgNode.setAttributeNS(null, "height", "15px");
      correctImgNode.setAttributeNS(null, "width", "15px");
      // correctImgNode.setAttributeNS(null, "transform", transform);
      seat.appendChild(correctImgNode);
    } else {
      if (!iconCorrectNode) return;
      iconCorrectNode.remove();
      // const iconCorrectNodes = document.querySelectorAll(`.icon_correct_${seatId}`);
      // for (let i = 0; i < iconCorrectNodes.length; i++) {
      //   const iconCorrectNode = iconCorrectNodes[i];
      //   seat.removeChild(iconCorrectNode);
      // }
    }
  };
  render() {
    return (
      <PinchZoomPan
        minScale={1}
        maxScale={3}
        mouseWheel={false}
        zoomButtons={false}
      >
        <LoadSvg
          file={`${process.env.PUBLIC_URL}/assets/images/mapsit.svg`}
          onLoaded={() => this.setState({ onReady: true })}
        />
      </PinchZoomPan>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Booking/Mapsit.js